var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "abhero" }, [
    _c(
      "div",
      { staticClass: "abhero__rows" },
      _vm._l(_vm.localRows, function (row, idx) {
        return _c("div", { key: row.key, staticClass: "abhero__rowwrap" }, [
          _c("div", { staticClass: "abhero__row" }, [
            _c("div", { staticClass: "abhero__label" }, [
              _vm._v("\n          " + _vm._s(row.label) + "\n        "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "abhero__input",
                class: {
                  "abhero__input--disabled": _vm.disabled,
                  "abhero__input--original": _vm.isOriginal(row),
                },
              },
              [
                _vm.isOriginal(row)
                  ? [
                      _vm.sourceThumb && !_vm.sourceThumbError
                        ? _c("img", {
                            staticClass: "abhero__thumb abhero__thumb--dashed",
                            attrs: {
                              src: _vm.sourceThumb,
                              "data-fullsrc": _vm.sourceFull,
                              alt: "",
                            },
                            on: {
                              error: function ($event) {
                                _vm.sourceThumbError = true
                              },
                            },
                          })
                        : _c("i", {
                            staticClass:
                              "bi bi-image abhero__thumb abhero__thumb--fallback",
                            attrs: { title: "Original source image" },
                          }),
                      _vm._v(" "),
                      _c("span", { staticClass: "abhero__originaltext" }, [
                        _vm._v("Original source image"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "abhero__clear",
                          attrs: {
                            type: "button",
                            disabled: _vm.disabled,
                            title: "Use AI instead",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.clearOriginal(idx)
                            },
                          },
                        },
                        [_vm._v("\n              ×\n            ")]
                      ),
                    ]
                  : [
                      row.image &&
                      _vm.thumbSrc(row) &&
                      !_vm.thumbErrors[row.key]
                        ? _c("img", {
                            staticClass: "abhero__thumb",
                            attrs: {
                              src: _vm.thumbSrc(row),
                              "data-fullsrc": _vm.fullSrc(row),
                              alt: "",
                            },
                            on: {
                              error: function ($event) {
                                return _vm.$set(_vm.thumbErrors, row.key, true)
                              },
                            },
                          })
                        : row.image && _vm.thumbErrors[row.key]
                        ? _c("i", {
                            staticClass:
                              "bi bi-image abhero__thumb abhero__thumb--fallback",
                            attrs: {
                              title: "Selected image (preview unavailable)",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: row.text,
                            expression: "row.text",
                          },
                        ],
                        staticClass: "abhero__text",
                        attrs: {
                          rows: "1",
                          placeholder: _vm.placeholderFor(row),
                          disabled: _vm.disabled,
                        },
                        domProps: { value: row.text },
                        on: {
                          paste: function ($event) {
                            return _vm.onPaste(idx, $event)
                          },
                          input: [
                            function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(row, "text", $event.target.value)
                            },
                            function ($event) {
                              return _vm.onText($event)
                            },
                          ],
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "abhero__icons" }, [
                        _vm.hasText(row) || row.image
                          ? _c(
                              "button",
                              {
                                staticClass: "abhero__clear",
                                attrs: {
                                  type: "button",
                                  disabled: _vm.disabled,
                                  title: "Clear",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.clearContent(idx)
                                  },
                                },
                              },
                              [_vm._v("\n                ×\n              ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "abhero__icon",
                            attrs: {
                              type: "button",
                              disabled: _vm.disabled,
                              title: "Upload from device",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.pick(idx, "upload")
                              },
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "abhero__icon-svg",
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "15",
                                  height: "15",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "aria-hidden": "true",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "abhero__icon",
                            attrs: {
                              type: "button",
                              disabled: _vm.disabled,
                              title: "Pick from file browser or Salsify",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.pick(idx, "browser")
                              },
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "abhero__icon-svg",
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "15",
                                  height: "15",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "aria-hidden": "true",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        row.key !== "source"
                          ? _c(
                              "button",
                              {
                                staticClass: "abhero__icon",
                                attrs: {
                                  type: "button",
                                  disabled: _vm.disabled,
                                  title: "Save or reuse a prompt",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.promptClipboard(idx)
                                  },
                                },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "abhero__icon-svg",
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "15",
                                      height: "15",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "aria-hidden": "true",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .962 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.962 0z",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("path", { attrs: { d: "M20 3v4" } }),
                                    _vm._v(" "),
                                    _c("path", { attrs: { d: "M22 5h-4" } }),
                                    _vm._v(" "),
                                    _c("path", { attrs: { d: "M4 17v2" } }),
                                    _vm._v(" "),
                                    _c("path", { attrs: { d: "M5 18H3" } }),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        row.key !== "source"
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "abhero__icon abhero__icon--useorig",
                                attrs: {
                                  type: "button",
                                  disabled: _vm.disabled,
                                  title: "Use original",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.useOriginal(idx)
                                  },
                                },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "abhero__icon-svg",
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "15",
                                      height: "15",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "aria-hidden": "true",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: { d: "M14 2v5a1 1 0 0 0 1 1h5" },
                                    }),
                                    _vm._v(" "),
                                    _c("circle", {
                                      attrs: { cx: "10", cy: "12", r: "2" },
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d: "m20 17-1.296-1.296a2.41 2.41 0 0 0-3.408 0L9 22",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ],
              ],
              2
            ),
          ]),
          _vm._v(" "),
          row.key !== "source" &&
          !_vm.disabled &&
          !_vm.isOriginal(row) &&
          !_vm.hasText(row) &&
          _vm.samplesFor(row).length
            ? _c(
                "div",
                { staticClass: "abhero__samplewrap" },
                _vm._l(_vm.samplesFor(row), function (ex, exIdx) {
                  return _c(
                    "button",
                    {
                      key: exIdx,
                      staticClass: "abhero__sample",
                      class: { "abhero__sample--clamp": ex.clamp },
                      attrs: {
                        type: "button",
                        disabled: _vm.disabled,
                        title: ex.text,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.applyChip(idx, ex.text)
                        },
                      },
                    },
                    [_vm._v("\n          " + _vm._s(ex.label) + "\n        ")]
                  )
                }),
                0
              )
            : _vm._e(),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "abhero__footer" }, [
      _c("label", { staticClass: "abhero__size" }, [
        _c("span", { staticClass: "abhero__size-label" }, [
          _vm._v("Image size"),
        ]),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localSize,
                expression: "localSize",
              },
            ],
            staticClass: "abhero__size-select",
            attrs: {
              disabled: _vm.disabled,
              title: "Output size — PDP images are square (1:1)",
            },
            on: {
              change: [
                function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.localSize = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
                _vm.emitState,
              ],
            },
          },
          _vm._l(_vm.sizeOptions, function (opt) {
            return _c("option", { key: opt, domProps: { value: opt } }, [
              _vm._v(
                "\n          " + _vm._s(opt.replace("x", " × ")) + "\n        "
              ),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "abhero__generate",
          attrs: { type: "button", disabled: !_vm.canGenerate || _vm.disabled },
          on: { click: _vm.generate },
        },
        [
          !_vm.generating
            ? _c("span", [
                _vm._v("Generate "),
                _c("i", { staticClass: "bi bi-arrow-right" }),
              ])
            : _c("span", [
                _vm._v("Generating "),
                _c("span", { staticClass: "abhero__dots" }, [_vm._v("···")]),
              ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }